export default __webpack_public_path__ + "static/media/VA.8e3ea81b.svg";